/* import __COLOCATED_TEMPLATE__ from './segmented-control.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import templateOnlyComponent from '@ember/component/template-only';
import { type Invokable } from '@glint/template/-private/integration';

interface Signature {
  Args: {
    onSelectionChange: (value: string) => void;
    selectedValue: string;
  };
  Element: HTMLSpanElement;
  Blocks: {
    default: [
      {
        button: Invokable<any>;
      },
    ];
  };
}

const SegmentedControl = templateOnlyComponent<Signature>();
export default SegmentedControl;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::FinReadiness::SegmentedControl': typeof SegmentedControl;
    'reporting/automation/ai-insights/fin-readiness/segmented-control': typeof SegmentedControl;
  }
}
